import React from "react";
import { Link } from "@mui/material";
import Thumbnail from "./Thumbnail";
import ShowLoopContentPreview from "./ShowLoopContentPreview";

const ContentThumbnailWithPreview = ({ visualInfo }) => {
    const [loadPreview, setLoadPreview] = React.useState(false);
    const [previewInfo, setpreviewInfo] = React.useState({});

    return (
        <>
            <Link
                href="#"
                underline="none"
                title={visualInfo.content}
                sx={{ color: "#AF3241" }}
                onClick={(e) => {
                    e.preventDefault();
                    setpreviewInfo(visualInfo);
                    setLoadPreview(true);
                }}
            >
                <Thumbnail visualName={visualInfo.content} url={visualInfo.thumbnail_url} />
            </Link>
            {/* ------ load picture ------ */}
            {loadPreview === true && (
                <ShowLoopContentPreview
                    open={loadPreview}
                    onClose={() => {
                        setLoadPreview(false);
                    }}
                    size={"md"}
                    loopInfo={previewInfo}
                    closeModal={() => {
                        setLoadPreview(false);
                    }}
                />
            )}
        </>
    );
};

export default ContentThumbnailWithPreview;
